import classNames from 'classnames'

type Tab = { title: string }

interface TabProps<T> {
  title: string
  active: boolean
  onSet: (arg0: T) => void
}

const Tab = ({ onSet, active, ...props }: TabProps<Tab>) => {
  const clsnm = classNames(
    'inline-block flex-1 text-center py-4 rounded-md text-sm leading-loose font-md cursor-pointer',
    {
      'bg-blue': active,
      'text-white': active,
    },
  )

  return (
    <div className={clsnm} onClick={(_e) => onSet(props)}>
      {props.title}
    </div>
  )
}

type Props<T extends Tab> = {
  tabs: {
    [idx: string]: T
  }
  onSet: (tab: T) => void
  current: string
}

const TabBar = <T extends Tab>({ current, onSet, tabs }: Props<T>) => {
  const keys = Object.keys(tabs)
  return (
    <div>
      <select
        value={current}
        onChange={(e) => onSet(tabs[e.target.value])}
        className="lg:hidden form-select bg-white bright:bg-gray-700 text-black font-medium w-full border-none focus:border-none rounded-md my-4 p-6"
      >
        {keys.map((k) => (
          <option key={k} value={k}>
            {tabs[k].title}
          </option>
        ))}
      </select>
      <div className="justify-between hidden lg:flex bright:bg-white bright:shadow-xl light:bg-white black:bg-white black:text-black rounded-md">
        {keys.map((k) => (
          <Tab key={k} active={current === k} onSet={onSet} {...tabs[k]} />
        ))}
      </div>
    </div>
  )
}

export default TabBar
